import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';
import { BulkApplicantMessage } from '@app/modules/applicant-tracker/interfaces/bulk-applicant-message';
import { AuthService } from '@app/services';
import { BaseForm } from '@forms/base.form';
import { ApplicantMessageTemplate } from '@models/recruiting/applicant-message-template.model';
import { JobPosting } from '@models/recruiting/job-posting.model';
import { JobFunnelNameOptions } from '@app/types/translatables/applicant-tracker/job-funnel-name.options';

@Component({
    selector: 'app-bulk-applicant-message-form',
    templateUrl: './bulk-applicant-message.form.html',
})
export class BulkApplicantMessageForm extends BaseForm {
    @ViewChild('jobFunnelSelect') jobFunnelSelect: MatSelectModule;

    @Input() bulkApplicantMessage: BulkApplicantMessage;
    @Input() jobPostingId: number;
    @Output() jobPostingIdChange: EventEmitter<number> = new EventEmitter<number>();
    @Output() isLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

    jobPostings: JobPosting[];
    selectedJobPosting: JobPosting;

    templateId: number | string = 'free-form';
    previousTemplateId: number | string;
    applicantMessageTemplates: ApplicantMessageTemplate[];
    isTemplateModalOpen = false;
    jobFunnelNameDisplayOptions = JobFunnelNameOptions;

    constructor(
        public route: ActivatedRoute,
        public auth: AuthService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.isLoading.emit(true);
        ApplicantMessageTemplate.all().then(([applicantMessageTemplates]) => {
            this.applicantMessageTemplates = applicantMessageTemplates;
        });

        JobPosting.param('company', this.auth.company.id)
            .orderBy('createdAt', 'desc')
            .with(['jobFunnels', 'jobFunnels.activeApplicants'])
            .all()
            .then(([jobPostings]) => {
                this.jobPostings = jobPostings;

                if (this.jobPostingId) {
                    this.onJobPostingChange();
                }
                this.isLoading.emit(false);
            });
    }

    onJobPostingChange(): void {
        this.bulkApplicantMessage.atsJobFunnelId = null;

        this.selectedJobPosting = this.jobPostings.find((jobPosting) => jobPosting.id === this.jobPostingId);
        this.jobPostingIdChange.emit(this.selectedJobPosting.id);
    }

    setPreviousTemplateId(newVal: string | number): void {
        this.previousTemplateId = this.templateId;
        this.templateId = newVal;
    }

    resetTemplateId(): void {
        this.templateId = this.previousTemplateId;
        this.closeTemplateModal();
    }

    canOverride(): void {
        if (this.bulkApplicantMessage.body) {
            this.openTemplateModal();
            return;
        }

        this.onTemplateIdChange();
    }

    openTemplateModal(): void {
        this.isTemplateModalOpen = true;
    }

    closeTemplateModal(): void {
        this.isTemplateModalOpen = false;
    }

    onTemplateIdChange(): void {
        const template = this.applicantMessageTemplates.find((t) => t.id === this.templateId);
        this.closeTemplateModal();

        if (!template) {
            this.bulkApplicantMessage.subject = '';
            // Quill does not empty the body correctly with an empty string so we add a space
            this.bulkApplicantMessage.body = ' ';
            return;
        }

        this.bulkApplicantMessage.subject = template.subject;
        this.bulkApplicantMessage.body = template.body;
    }
}
